import ReceivablesSideBar from "../ReceviablesSideBar"
import receCss from "../../../css/receivablesListing.module.css"
import React from 'react';
import { useState, useEffect, useRef } from "react";
import { useHistory, useParams } from 'react-router-dom';
import Select from "react-select";
import swal from "sweetalert";
import { toast } from "react-toastify";

import {ReactComponent as FilterIcon} from "../../../assets/icons/filter.svg"
import {ReactComponent as Plus} from "../../../assets/icons/plus.svg"
import {ReactComponent as CalenderIcon} from "../../../assets/icons/calenderIcon.svg"
import { ReactComponent as CustModeLCloseIcon }  from '../../../assets/icons/custModeLCloseIcon.svg'
import { ReactComponent as LoansUploadIcon }  from '../../../assets/icons/loansUploadIcon.svg'
import { ReactComponent as RemoveLoanIcon }  from '../../../assets/icons/removeLoansIcons.svg'
import { ReactComponent as UploadReceivables }  from '../../../assets/icons/receivablesUpload.svg'
import { ReactComponent as PullReceivableSvg }  from '../../../assets/icons/receivablesPull.svg'
import { ReactComponent as ErpCardDots }  from '../../../assets/icons/erpCardDots.svg'
import { ReactComponent as ErpClock }  from '../../../assets/icons/erpClock.svg'
import UserTwoImg  from '../../../assets/imgs/user2.png'

import { receivablesListing, receivablesUploadFiles, GetReceivableMapping, saveReceivableMapping, GetSubReceivableMapping, subReceivablemapping, getAllReceivablesErpData, putReceivableFromERP } from '../../../../Bookclosure/Services/ApiHandler'

import Table from "../../../elements/Table"
import ReceivableListingFilterModel from "../../../components/receivables/Listing/ListingReceivableFilterModel"
import commoncss from "../../../css/common.module.css";


const LoansListing = () => {
    // const [receivablesID, setreceivablesID] = useState('676cf724e5e1156fbf63b571')

    const { id, companyId } = useParams();

    const [receivablesID, setreceivablesID] = useState(id)
    const [ReceivablesUploadModal,setReceivablesUploadModal] = useState(false)
    
    // receivables Mapping model
    const [ReceivablesMapping,setReceivablesMapping] = useState(false)
    
    // receivables Mapping model
    const [subReceivablesMapping,setsubReceivablesMapping] = useState(false)

    // receiables erp items list model
    const [receivablesERPModel, setreceivablesERPModel] = useState(false)
    const [erpSelectedReceivableId, seterpSelectedReceivableId] = useState()

    const [ReceivablesListThData,setReceivablesListThData] = useState()
    const [ReceivablesListTbData,setReceivablesListTbData] = useState()

    const [ReceivablesColumnMapVal, setReceivablesColumnMapVal] = useState({}); // Initialize to an empty object
    const [ReceivablesColumnMap, setReceivablesColumnMap] = useState([])
    
    const [subMappingActiveTab, setsubMappingActiveTab] = useState(1)
    
    const [perCategoryLabels, setperCategoryLabels] = useState()
    const [perCategoryFields, setperCategoryFields] = useState()
    
    const [perCurrencyLables, setperCurrencyLables] = useState()
    const [perCurrencyFields, setperCurrencyFields] = useState()

    // const [perProductClassfLables, setperProductClassfLables] = useState()
    // const [perProductClassfFields, setperProductClassfFields] = useState()

    const [selectedSubMappingData, setSelectedSubMappingData] = useState({
        categorySubmap: [],
        currencySubmap: [],
    });
    const [filterAttr, setFilterAttr] = useState([]);
    const [filterLoanData, setFilterLoanData] = useState({}); // <-- State for filter data
    const handleSetSelectChange = (selectedOption, index, tab) => {
        let label = '';
        if (tab === 'Category') label = perCategoryLabels[index];
        else if (tab === 'Currency') label = perCurrencyLables[index];
        // else if (tab === 'productClassification') label = perProductClassfLables[index];

        // setSelectedSubMappingData(prev => {
        //     const updated = [...prev[tab + 'Stages']];
        //     updated[index] = {
        //     key: label || '', // ensure key is always set
        //     values: [selectedOption.value]
        //     };
        //     return {
        //     ...prev,
        //     [tab + 'Stages']: updated
        //     };
        // });

        setSelectedSubMappingData(prev => {
            const updated = [...prev.categorySubmap];
            updated[index] = {
                key: label || '',
                values: [selectedOption.value]
            };

            return {
                ...prev,
                categorySubmap: updated
            };
        });

    };

    useEffect(() => {
        setReceivablesColumnMapVal({
            // Basic Customer and Receivables Identifiers
            "customerID": "Supplier code",   
            "customerName": "Supplier spmn supname", 
            "docDate": "Doc Date",
            "dueDays": "Due days",
            "dueDate": "Due date",
            "foreignCurrency": "Doc Currency",
            "exchangeCurrencyValue": "Exchange Rate",
            "GLAccountCode": "Account Code",
            "business": "Business",
            "businessPersonResponsible": "Business person responsible",
            "provision": "Provision",
            "category": "O/s category",
        })
    }, [])
    

    useEffect(() => {

        // // This code inside useEffect will run only once after the component first mounts.
        // setReceivablesColumnMapVal({
                // "customerID": "",
                // "customerName": "",
                // "docDate": "",
                // "dueDays": "",
                // "dueDate": "",
                // "foreignCurrency": "",
                // "exchangeCurrencyValue": "",
                // "GLAccountCode": "",
                // "business": "",
                // "businessPersonResponsible": "",
                // "provision": "",
                // "category": ""
        // });

    }, []);
    const [filterOptions, setFilterOptions] = useState({});
    useEffect(() => {
        const getFilterOptions = async () => {
            try {
                const response = await receivablesListing(receivablesID);
                const allLoans = response.data.receivableListing;
                // Create a single object with all unique values
                const uniqueOptions = {
                    customerIDs: [...new Set(allLoans.map(loan => loan.customerID))],
                    customerNames: [...new Set(allLoans.map(loan => loan.customerName))],
                    productIDs: [...new Set(allLoans.map(loan => loan.productID))],
                    productNames: [...new Set(allLoans.map(loan => loan.productName))],
                    loanIDs: [...new Set(allLoans.map(loan => loan.loanID))],
                };
                // Update the state with the single object
                setFilterOptions(uniqueOptions);
                console.log("Filter options:", uniqueOptions);
            } catch (error) {
                console.error("Failed to fetch filter options:", error);
            }
        };
        getFilterOptions();
    }, [receivablesID]);

    // Loans listing api 
    useEffect(() => {
            getReceivableListingData(receivablesID, filterLoanData)

            // receivablesListing(receivablesID).then((res) => {
            //     const headers = res?.data?.receivableListingHeaders.map((h) => ({
            //     header: h,
            //     accessor: h,
            //     }));
            //     setReceivablesListThData(headers);
            //     setReceivablesListTbData(res?.data?.receivableListing);
            // });
        },
    []);
    receivablesListing(receivablesID, {}).then((res) => { })
    const getReceivableListingData = (receivablesID, filterLoanData) => {
            receivablesListing(receivablesID, filterLoanData).then((res) => {
                const displayHeaderMap = {
                    "customerID": "Supplier code",   
                    "customerName": "Supplier spmn supname", 
                    "docDate": "Doc Date",
                    "dueDays": "Due days",
                    "dueDate": "Due date",
                    "foreignCurrency": "Doc Currency",
                    "exchangeCurrencyValue": "Exchange Rate",
                    "GLAccountCode": "Account Code",
                    "business": "Business",
                    "businessPersonResponsible": "Business person responsible",
                    "provision": "Provision",
                    "category": "O/s category",
                            
                };
                const headers = res.data.receivableListingHeaders.map((h) => ({
                    // header: h,
                    header: displayHeaderMap[h] || h,
                    accessor: h,
                }));
                setReceivablesListThData(headers);
                setReceivablesListTbData(res.data.receivableListing);
    
                if (res.data.filterAndAlignment) {
                    setFilterAttr(res.data.filterAndAlignment);
                }
            });
        }

    const fileInputRef = useRef(null);
    const handleManualUpload = () => {
        fileInputRef.current.click();
    };

    // arranging data in to object to send api
    const handleSelectChange = (keyName, selectedOption) => {
        // keyName will be "customerID", "customerName", "productID", etc.
        // selectedOption will be the object from react-select (e.g., { value: "Actual Excel Column Name", label: "Actual Excel Column Name" })

        setReceivablesColumnMapVal(prevMapping => ({
            ...prevMapping, // Keep all the previous key-value pairs
            [keyName]: selectedOption ? selectedOption.value : '' // Update only the specific key with the new selected value
        }));
    };

    
   
    // getting loans data
    const GetLoanMappingData = () => {
        GetReceivableMapping(receivablesID).then((res) => {
            let loansFieldsLst = res.data.fields
    
            // Map loan list to dropdown format
            const formattedOptions = loansFieldsLst.map(loansFieldsLst => ({
                value: loansFieldsLst,
                label: loansFieldsLst
            }));
    
            setReceivablesColumnMap(formattedOptions);
            setReceivablesMapping(true)

        })
    }


     // sending loans mapping object
    const saveColumnMapping = () => {
        saveReceivableMapping(receivablesID,ReceivablesColumnMapVal).then(res => {
            // hide the loan mapping
            setReceivablesMapping(false)
            
            // get the sub mapping data 
            GetSubLoanMappingData()

            // un hide the sub loan mapping
            setsubReceivablesMapping(true)
        })
    }


    // getting sub Mapping data
    const GetSubLoanMappingData = () => {

        GetSubReceivableMapping(receivablesID, 'category').then((res) => {
            let receFieldsLst = res.data.fields
            let labelList = res.data.labelList
    
            // Map loan list to dropdown format
            const formattedOptions = receFieldsLst.map(receFieldsLst => ({
                value: receFieldsLst,
                label: receFieldsLst
            }));
    
            setperCategoryFields(formattedOptions);
            setperCategoryLabels(labelList)
        })

        GetSubReceivableMapping(receivablesID, 'foriegnCurrency').then((res) => {
            let receFieldsLst = res.data.fields
            let labelList = res.data.labelList
    
            // Map loan list to dropdown format
            const formattedOptions = receFieldsLst.map(receFieldsLst => ({
                value: receFieldsLst,
                label: receFieldsLst
            }));
    
            setperCurrencyFields(formattedOptions);
            setperCurrencyLables(labelList)
        })

    }

    const saveSubMapping = () => {
        subReceivablemapping(receivablesID, selectedSubMappingData).then(res => {
            setsubReceivablesMapping(false)
            toast.success("Receivables added successfully.");
        })
    }

    // Model
    const [receivableSelectModel,setloanSelectModel] = useState(false)
    const [erpList, setErpList] = useState([]);

    const [selectedCardId, setSelectedCardId] = useState(null);


    const handleModels = (model) => {
        
        setloanSelectModel(false)

        if(model === 'erp'){
            GetErpData()
        }

        if(model === 'uploadLoansFile'){
            setReceivablesUploadModal(true)
        }
    }

    const GetErpData = () => {
        getAllReceivablesErpData(receivablesID).then(res => {
            setErpList(res.data.ERPReceivableList);
            setreceivablesERPModel(true)
        })
    }
    
    const setReceivableId = () => {
        if(selectedCardId){
            putReceivableFromERP(receivablesID, selectedCardId).then(() => {
                    toast.success("ERP data pulled successfully");
                    setreceivablesERPModel(false)
                }   
            )
        }
    }
    const applyReceivablesListingFilter = (filterParams) => {
        getReceivableListingData(receivablesID, filterParams )
    }
    return(
        <div style={{ display: 'flex' }}>
            <ReceivablesSideBar
                id={id}
                companyId={companyId}
                activeTab={'Receivables Listing'}
            />
            <div className={receCss.loanListingMainContainer}>
                <ReceivablesListingHeader 
                    setloanSelectModel={setloanSelectModel}
                    setReceivablesUploadModal = {setReceivablesUploadModal}
                    filterAttr={filterAttr}
                    receivablesID={receivablesID}
                    applyReceivablesListingFilter={applyReceivablesListingFilter}
                    filterOptions={filterOptions}
                />
                <ReceivablesListingBody 
                    ReceivablesListThData={ReceivablesListThData} 
                    ReceivablesListTbData={ReceivablesListTbData}
                />

                {receivableSelectModel &&(
                    <SelectDataPullMethod 
                        setloanSelectModel={setloanSelectModel}
                        handleModels={handleModels}
                    />
                )}
                
                {ReceivablesUploadModal &&(
                    <React.Fragment>
                        <ReceivablesUploadModel 
                            fileInputRef={fileInputRef}
                            handleManualUpload={handleManualUpload}
                            setReceivablesUploadModal = {setReceivablesUploadModal}
                            receivablesID={receivablesID}
                            setReceivablesMapping={setReceivablesMapping}
                            GetLoanMappingData={GetLoanMappingData}
                        />
                    </React.Fragment>
                )}

                {receivablesERPModel &&(
                    <React.Fragment>
                        <ReceivablesERPItemsModel 
                            selectedCardId={selectedCardId}
                            setSelectedCardId={setSelectedCardId}
                            erpList={erpList}
                            erpSelectedReceivableId={erpSelectedReceivableId} 
                            seterpSelectedReceivableId={seterpSelectedReceivableId}
                            setreceivablesERPModel={setreceivablesERPModel}
                            setReceivableId={setReceivableId}
                        />
                    </React.Fragment>
                )}

                {ReceivablesMapping &&(
                    <React.Fragment>
                        <ReceivablesMappingModel 
                            ReceivablesColumnMap={ReceivablesColumnMap}
                            ReceivablesColumnMapVal={ReceivablesColumnMapVal}
                            setReceivablesColumnMapVal={setReceivablesColumnMapVal}
                            handleSelectChange={handleSelectChange}
                            saveColumnMapping={saveColumnMapping}
                            setReceivablesMapping={setReceivablesMapping}
                        />
                    </React.Fragment>
                )}
                
                {subReceivablesMapping &&(
                    <React.Fragment>
                        <SubReceivablesMappingModel 
                            subReceivablesMapping={subReceivablesMapping}
                            setsubReceivablesMapping={setsubReceivablesMapping}
                            subMappingActiveTab={subMappingActiveTab} 
                            setsubMappingActiveTab={setsubMappingActiveTab}
                            perCategoryLabels={perCategoryLabels}
                            perCategoryFields={perCategoryFields}
                            perCurrencyLables={perCurrencyLables}
                            perCurrencyFields={perCurrencyFields}
                            // perProductClassfLables={perProductClassfLables}
                            // perProductClassfFields={perProductClassfFields}
                            handleSetSelectChange={handleSetSelectChange}
                            selectedSubMappingData={selectedSubMappingData} 
                            setSelectedSubMappingData={setSelectedSubMappingData}
                            saveSubMapping={saveSubMapping}
                        />
                    </React.Fragment>
                )}
            </div>
        </div>
    )
}

export default LoansListing;


const SelectDataPullMethod = ({
    handleModels,
    setloanSelectModel,
}) => {
    return(
        <div className={`${receCss.cutModelForDragLaonsIrac} custmfadein`} onClick={() => {}} >
            <div className={receCss.stageTwocardsContainer}>
                <div className={receCss.popWrapperContainer}>
                    <div className={receCss.headerContainerFrPop}>
                        <div>Add Loans</div>
                        <div>
                            <CustModeLCloseIcon className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`} 
                                onClick={() => {setloanSelectModel(false)}}
                            />
                        </div>
                    </div>
                    <div className={receCss.boxsWrapperContainer}>
                        <div>
                            <PullReceivableSvg className={receCss.stagetwocards} onClick={() => {handleModels('erp')} }/>
                        </div>
                            <UploadReceivables className={receCss.stagetwocards} onClick={() => {handleModels('uploadLoansFile')}}/>
                        <div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
} 

const ReceivablesListingHeader = ({
    setReceivablesUploadModal,
    setloanSelectModel,
    filterAttr,
    receivablesID,
    applyReceivablesListingFilter,
    filterOptions
    }) => {
    const [displayModal, setDisplayModal] = useState(false);
    const [receivablelistingFilterModel, setReceivableListingFilterModel] = useState(false);
        
    const closeListingFilterModal  = () => {
            setDisplayModal(false);
    };
    return(
        <>
        <div className={receCss.w100}>
            <div className={receCss.uploadLoansMainContainer}>
            </div>
            <div className={receCss.listPageheader}>
                <div className={receCss.loanHeaderLeftContainer}>
                    <div className={receCss.heading}>Receivables Listing</div>
                </div>
                <div className={receCss.loanHeaderRightContainer}>
                    <div className={receCss.filterContainer}>
                        {/* <FilterIcon /> */}
                        <FilterIcon className={commoncss.clickable} width={20} height={20} onClick={() => { setReceivableListingFilterModel(true); setDisplayModal(true); }} />

                    </div>
                    <div className={receCss.calenderContainer}>
                        <div className={receCss.leftCalenderContainer}>
                            <div className={receCss.calenderLabels}>
                                From
                            </div>
                            <div className={receCss.calenderDate}>
                                01-01-2024
                            </div>
                            <div className={receCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>

                        <div className={receCss.RightCalenderContainer}>
                            <div className={receCss.calenderLabels}>
                                To 
                            </div>
                            <div className={receCss.calenderDate}>
                                01-01-2024
                            </div>
                            <div className={receCss.calenderIconContainer}>
                                <CalenderIcon />
                            </div>
                        </div>
                    </div>
                    <div className={receCss.btnWrapper}>
                        <button
                            onClick={() => {setloanSelectModel(true);}} 
                            type="button" 
                            className={receCss.uploadPrimaryBtn}> 
                            <Plus className={`${receCss.plusIcon}`} />
                            Upload
                        </button>
                    </div>
                </div>
            </div>
        </div>
        {receivablelistingFilterModel && displayModal && (
            <ReceivableListingFilterModel
                handleClose={closeListingFilterModal}
                setReceivableListingFilterModel={setReceivableListingFilterModel}
                filterOptions={filterOptions}
                receivablesID={receivablesID}
                applyReceivablesListingFilter={applyReceivablesListingFilter}
                filterAttr={filterAttr}
            />
        )}
       </> 
    )
}


const ReceivablesListingBody = ({
    ReceivablesListThData,
    ReceivablesListTbData,
     }) => {
    const [colWidths, setColWidths] = useState([]);

useEffect(() => {
  const ths = document.querySelectorAll(`.${receCss.stickyTh} th`);
  const widths = Array.from(ths).map((th) => {
    const style = window.getComputedStyle(th);
    const paddingLeft = parseFloat(style.paddingLeft) || 0;
    const paddingRight = parseFloat(style.paddingRight) || 0;
    const borderLeft = parseFloat(style.borderLeftWidth) || 0;
    const borderRight = parseFloat(style.borderRightWidth) || 0;

    return th.offsetWidth - paddingLeft - paddingRight - borderLeft - borderRight;
  });
  setColWidths(widths);
}, [ReceivablesListTbData, ReceivablesListThData]);
  const TruncCell = ({ content, maxWidth }) => {
  const wrapperRef = useRef(null);
  const [tooltip, setTooltip] = useState(null);

  const isTruncated = () =>
    wrapperRef.current &&
    wrapperRef.current.scrollWidth > wrapperRef.current.clientWidth;

  return (
    <>
      <div
        ref={wrapperRef}
        style={{
          whiteSpace: "nowrap",
          overflow: "hidden",
          textOverflow: "ellipsis",
          boxSizing: "border-box",
          maxWidth: `${maxWidth}px`
        }}
        onMouseEnter={(e) => {
          if (!isTruncated()) return;
          const rect = e.target.getBoundingClientRect();
          setTooltip({
            text: content,
            x: rect.left + rect.width / 2,
            y: rect.top
          });
        }}
        onMouseLeave={() => setTooltip(null)}
      >
        {content}
      </div>

      {tooltip && (
        <div
          style={{
            position: "fixed",
            top: tooltip.y - 28,
            left: tooltip.x,
            transform: "translateX(-50%)",
            backgroundColor: "#333",
            color: "#fff",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "12px",
            whiteSpace: "nowrap",
            zIndex: 9999,
            pointerEvents: "none"
          }}
        >
          {tooltip.text}
        </div>
      )}
    </>
  );
};
    return(
        <div className={receCss.tableContianerCust}>
            <div className={`${receCss.tableContainer} ${receCss.customscroll}`}>
                <table className={receCss.customTable}>
                <thead>
                    <tr className={receCss.stickyTh}>
                        {ReceivablesListThData?.map((col, i) => (
                            <th key={i}>{col.header}</th>
                        ))}
                    </tr>
                </thead>
                <tbody>
                    {ReceivablesListTbData?.length > 0 ? (
                    ReceivablesListTbData?.map((row, i) => (
                        <tr key={i}>
                            {ReceivablesListThData?.map((col, j) => (
                                <td key={j} className={receCss.truncate}>
                                    
                                     <TruncCell content={row[col.accessor]} maxWidth={colWidths[j] || 100} />
                                    {/* {row[col.accessor]} */}
                                    </td>
                            ))}
                        </tr>
                    ))
                    ) : (
                    <tr>
                        <td colSpan={ReceivablesListThData?.length} style={{ textAlign: "center" }}>
                        No data found
                        </td>
                    </tr>
                    )}
                </tbody>
                </table>
            </div>
        </div>
    )
}


const ReceivablesUploadModel = ({
    setReceivablesUploadModal,
    fileInputRef,
    handleManualUpload,
    receivablesID,
    setReceivablesMapping,
    GetLoanMappingData
}) => {
    const [dragActive, setDragActive] = useState(false);
    const [file, setFile] = useState(null);
    const [uploading, setUploading] = useState(false); // New state for tracking upload status
    const [uploadError, setUploadError] = useState(null);

  const handleDrag = (e) => {
    e.preventDefault();
    e.stopPropagation();
    if (e.type === "dragenter" || e.type === "dragover") {
      setDragActive(true);
    } else if (e.type === "dragleave") {
      setDragActive(false);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setDragActive(false);
    if (e.dataTransfer.files[0]) {
      setFile(e.dataTransfer.files[0]);
    }
  };

    const handleFileChange = (e) => {
        if (e.target.files[0]) {
            setFile(e.target.files[0]);
        }
    };

    const handleRemoveFile = () => {
        setFile(null);
        // Crucial fix: Clear the input's value to allow re-uploading the same file
        if (fileInputRef.current) {
            fileInputRef.current.value = null; // or ''
        }
    };

    const uploadFileToApi = async () => {
        if (!file) {
            setUploadError("Please select a file to upload.");
            return;
        }

        if (!receivablesID) {
            setUploadError("Loan ID is missing. Cannot upload file.");
            return;
        }

        setUploading(true);
        setUploadError(null);

        const formData = new FormData();
        formData.append('file', file); // Key 'file' matches your Postman setup and backend expectation

        try {
            // Call your API function
            const result = await receivablesUploadFiles(receivablesID, formData); // Pass receivablesID and formData
            console.log('Upload successful:', result);
            GetLoanMappingData()
            setReceivablesUploadModal(false)

        } catch (error) {
            // Error handling from the API call
            console.error('Error uploading file:', error);
            // Check if error.response exists for more specific API error messages
            const errorMessage = error.response && error.response.data && error.response.data.message
                                 ? error.response.data.message
                                 : error.message || 'An unexpected error occurred during upload.';
            setUploadError(errorMessage);
        } finally {
            setUploading(false);
        }
    };

  return (
    <div
      className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
      onClick={() => {
        setReceivablesUploadModal(false);
      }}
    >
      <div
        className={receCss.cutmModelMainContainer}
        onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
      >
        <div className={receCss.custModelHeader}>
          <div className={receCss.custModelHeaderLabel}>Upload Receivable Register</div>
          <div className={receCss.custmCursor}>
            <CustModeLCloseIcon
              className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
              onClick={() => setReceivablesUploadModal(false)}
            />
          </div>
        </div>

        <div className={receCss.cutModelBodyContainerOne}>
          <div
            className={`${receCss.dragDropArea} ${dragActive ? receCss.dragActive : ''}`}
            onDragEnter={handleDrag}
            onDragOver={handleDrag}
            onDragLeave={handleDrag}
            onDrop={handleDrop}
          >
            <label htmlFor="file-upload" className={receCss.dragDropLabel}>
              Drag and drop your file here or
              <button type="button" 
                onClick={handleManualUpload}
                className={receCss.custModelUploadBtn}>
                    <LoansUploadIcon className={receCss.receUploadIcon} />
                    &nbsp; 
                    Upload
              </button>
            </label>
            <input
                id="file-upload"
                type="file"
                onChange={handleFileChange}
                className={receCss.hiddenFileInput}
                ref={fileInputRef}
            />
          </div>

          <div className={receCss.loanUploadInfo}>
            File you upload must contain all the mandatory fields for mapping.
            {/* Display upload error message */}
            {uploadError && (
                <p style={{ color: 'red', marginTop: '10px' }}>{uploadError}</p>
            )}

          </div>

          {file && (
            <p className={`${receCss.selectedFile} ${receCss.fileUploadedIcon}`}>
              File Name  {file.name} 
              <span className={receCss.fileRmIcon}
                onClick={() => {
                    // setFile(null)
                    handleRemoveFile();
                }}
            > 
                <RemoveLoanIcon /> 
            </span>
            </p>
          )}
        </div>

        <div className={receCss.cutModelFooterContainer}>
          <button
            type="button"
            onClick={() => setReceivablesUploadModal(false)}
            className={receCss.custModelFooterBtnSecondary}
          >
            Cancel
          </button>
          <button
            type="button"
            onClick={uploadFileToApi}
            className={receCss.custModelFooterBtnPrimary}
            disabled={uploading || !file || !receivablesID} // Disable if no file or no receivablesID
        >
            {uploading ? 'Uploading...' : 'Proceed'}
        </button>
        </div>
      </div>
    </div>
  );
};


const ReceivablesMappingModel = ({
    ReceivablesColumnMap,
    ReceivablesColumnMapVal,
    setReceivablesColumnMapVal,
    handleSelectChange,
    saveColumnMapping,
    setReceivablesMapping
}) => {

    return (
        <div
            className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={receCss.cutmModelMainContainerSecond}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={receCss.custModelHeader}>
                    <div className={receCss.custModelHeaderLabel}>Upload Loans</div>
                    <div className={receCss.custmCursor}>
                        <CustModeLCloseIcon
                        className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
                        onClick={() => {setReceivablesMapping(false);}}
                        />
                    </div>
                </div>

                <div className={`${receCss.cutModelBodyContainer} ${receCss.customscroll}`}>

                    <div className={receCss.selectRowContainer}>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Customer ID
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                // value={ReceivablesColumnMapVal?.val ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal?.val) : ''}
                                value={ReceivablesColumnMapVal['customerID'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['customerID']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerID', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Customer ID"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Customer Name
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['customerName'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['customerName']) : null}
                                onChange={(selectedOption) => handleSelectChange('customerName', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Customer Name"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Doc Date
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['docDate'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['docDate']) : null}
                                onChange={(selectedOption) => handleSelectChange('docDate', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Doc Date"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={receCss.selectRowContainer}>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Due Days
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['dueDays'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['dueDays']) : null}
                                onChange={(selectedOption) => handleSelectChange('dueDays', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Due Days"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Due Date
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['dueDate'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['dueDate']) : null}
                                onChange={(selectedOption) => handleSelectChange('dueDate', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Due Date"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Foreign Currency
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['foreignCurrency'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['foreignCurrency']) : null}
                                onChange={(selectedOption) => handleSelectChange('foreignCurrency', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Foreign Currency"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={receCss.selectRowContainer}>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Exchange currency value
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['exchangeCurrencyValue'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['exchangeCurrencyValue']) : null}
                                onChange={(selectedOption) => handleSelectChange('exchangeCurrencyValue', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Exchange currency.."
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  GL Account Code
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['GLAccountCode'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['GLAccountCode']) : null}
                                onChange={(selectedOption) => handleSelectChange('GLAccountCode', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select GL Account Code"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Business
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['business'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['business']) : null}
                                onChange={(selectedOption) => handleSelectChange('business', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Business"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>

                    <div className={receCss.selectRowContainer}>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Business Person Responsible
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['businessPersonResponsible'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['businessPersonResponsible']) : null}
                                onChange={(selectedOption) => handleSelectChange('businessPersonResponsible', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Business Person.."
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Provision
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['provision'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['provision']) : null}
                                onChange={(selectedOption) => handleSelectChange('provision', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Provision"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                        <div className={receCss.selectContainer}>
                            <div className={receCss.custmLabel}>
                                <span className={receCss.reqiredField}>*</span>
                                  Category
                                </div>
                            <Select
                                components={{ IndicatorSeparator: () => null }}
                                value={ReceivablesColumnMapVal['category'] ? ReceivablesColumnMap.find(option => option.value === ReceivablesColumnMapVal['category']) : null}
                                onChange={(selectedOption) => handleSelectChange('category', selectedOption)}
                                options={ReceivablesColumnMap}
                                placeholder="Select Category"
                                name="status"
                                className={`mt-0 ${receCss.scenarioSelect}`}
                                classNamePrefix="select"
                                styles={customStyles}
                                isClearable={false}
                                isSearchable={false}
                            />
                        </div>
                    </div>
                
                </div>

                <div className={receCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => {setReceivablesMapping(false);}}
                        className={receCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => {saveColumnMapping()}}
                        className={receCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
  );
};


const ReceivablesERPItemsModel = ({
    selectedCardId,
    setSelectedCardId,
    erpList,
    setreceivablesERPModel,
    setReceivableId,
}) => {
    
    return (
        <div
            className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={receCss.cutmModelMainContainerSecond}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={receCss.custModelHeader}>
                    <div className={receCss.custModelHeaderLabel}>Add Receivable Register</div>
                    <div className={receCss.custmCursor}>
                        <CustModeLCloseIcon
                        className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
                        onClick={() => {setreceivablesERPModel(false);}}
                        />
                    </div>
                </div>

                <div className={receCss.cutModelBodyContainer}>

                    <div className={receCss.selectRowErpContainer}>
{/* 
                        <div className={receCss.erpCard}>
                            <div className={receCss.erpcardHeader}>
                                <div className={receCss.erpcardHeading}>
                                    Package Name
                                </div>
                                <div>
                                    <ErpCardDots />
                                </div>
                            </div>
                            <div className={receCss.erpcardBody}>
                                <div className={receCss.dateContainer}>
                                    <div className={receCss.calenderContainerWrapper}>
                                        <CalenderIcon className={receCss.iconSize} /> &nbsp; Feb 11, 2025
                                    </div>
                                    &nbsp;
                                    &nbsp;
                                    <div className={receCss.toTxt}>To</div>
                                    &nbsp;
                                    &nbsp;
                                    <div className={receCss.calenderContainerWrapper}>
                                        <CalenderIcon className={receCss.iconSize} /> &nbsp; Aug 15, 2025
                                    </div>
                                </div>
                                <div className={receCss.dFlex}>
                                    <ErpClock className={receCss.iconSize} /> 
                                    &nbsp;
                                    Apr 10, 2025 &nbsp; 08:34
                                </div>
                                <div className={receCss.dFlex}>
                                    <img className={receCss.userIcon} src={UserTwoImg} />
                                    &nbsp;
                                    &nbsp;
                                    <div>Adrienne Vossler</div>
                                </div>
                            </div>
                        </div> */}

                        {erpList.map((item) => (
                            <div
                                key={item._id}
                                className={`${receCss.erpCard} ${selectedCardId === item._id ? receCss.selectedCard : ''}`}
                                onClick={() => setSelectedCardId(item._id)}
                            >
                                <div className={receCss.erpcardHeader}>
                                <div className={receCss.erpcardHeading}>
                                    {item?.name || 'Package Name'}
                                </div>
                                <div><ErpCardDots /></div>
                                </div>

                                <div className={receCss.erpcardBody}>
                                <div className={receCss.dateContainer}>
                                    <div className={receCss.calenderContainerWrapper}>
                                    <CalenderIcon className={receCss.iconSize} /> &nbsp;
                                    {new Date(item.datecreated).toDateString()}
                                    </div>
                                </div>

                                <div className={receCss.dFlex}>
                                    <ErpClock className={receCss.iconSize} />
                                    &nbsp;
                                    {new Date(item.datecreated).toLocaleString()}
                                </div>

                                <div className={receCss.dFlex}>
                                    <img className={receCss.userIcon} src={UserTwoImg} />
                                    &nbsp;&nbsp;
                                    <div>Adrienne Vossler</div>
                                </div>
                                </div>
                            </div>
                        ))}




                    </div>
                
                </div>

                <div className={receCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => {setreceivablesERPModel(false);}}
                        className={receCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={() => {setReceivableId()}}
                        className={receCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
  );
};



const SubReceivablesMappingModel = ({
    setsubReceivablesMapping,
    subReceivablesMapping,
    subMappingActiveTab, 
    setsubMappingActiveTab,
    perCategoryLabels,
    perCategoryFields,
    // perProductClassfLables,
    // perProductClassfFields,
    perCurrencyLables,
    perCurrencyFields,
    handleSetSelectChange,
    selectedSubMappingData, 
    setSelectedSubMappingData,
    saveSubMapping
    }) => {

    return (
        <div
            className={`${receCss.cutModelForDragLaonsIrac} custmfadein`}
            onClick={() => {}}>
            <div
                className={receCss.cutmModelMainContainerThird}
                onClick={(e) => e.stopPropagation()} // prevent modal close on inside click
                >
                <div className={receCss.custModelHeader}>
                    <div className={receCss.custModelHeaderLabel}>Sub Mapping</div>
                    <div className={receCss.custmCursor}>
                        <CustModeLCloseIcon
                        className={`${receCss.custModelHeaderCloseicon} ${receCss.cursiorPointer}`}
                        onClick={() => {setsubReceivablesMapping(false)}}
                        />
                    </div>
                </div>

                {/* subMappingActiveTab, setsubMappingActiveTab */}
                <div className={receCss.wrapperContainerSubMap}>
                    <div className={receCss.loansSubMapTabsContainer}>
                        <div onClick={() => {setsubMappingActiveTab(1)}} className={ subMappingActiveTab === 1 ? receCss.subMapTabsActive : receCss.subMapTabs }>Category</div>
                        <div onClick={() => {setsubMappingActiveTab(2)}} className={ subMappingActiveTab === 2 ? receCss.subMapTabsActive : receCss.subMapTabs }>Currency</div>
                        {/* <div onClick={() => {setsubMappingActiveTab(3)}} className={ subMappingActiveTab === 3 ? receCss.subMapTabsActive : receCss.subMapTabs }>Product Classification</div> */}
                    </div>
                    {
                        subMappingActiveTab === 1 ?  
                            <div className={receCss.selectContainerWrapper}>
                                {perCategoryLabels?.map((label, index) => (
                                    <div className={receCss.selectContainerTab} key={index}>
                                        <div>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }}
                                            key={index}
                                            value={selectedSubMappingData.categorySubmap[index]?.values?.[0] 
                                                ? { label: selectedSubMappingData.categorySubmap[index].values[0], value: selectedSubMappingData.categorySubmap[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'Category')}
                                            options={perCategoryFields} // Provide the options for the current dropdown
                                            placeholder="Select Scenario"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${receCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                        />
                                    </div>
                                ))}
                            </div>
                        :     
                        subMappingActiveTab === 2 ? 
                            <div className={receCss.selectContainerWrapper}>
                                {perCurrencyLables?.map((label, index) => (
                                    <div className={receCss.selectContainerTab} key={index}>
                                        <div>{label}</div>
                                        <Select
                                            components={{ IndicatorSeparator: () => null }}
                                            key={index}
                                            value={selectedSubMappingData.currencySubmap[index]?.values?.[0] 
                                                ? { label: selectedSubMappingData.currencySubmap[index].values[0], value: selectedSubMappingData.currencySubmap[index].values[0] }
                                                : null
                                            }
                                            onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'Currency')}
                                            options={perCurrencyFields} // Provide the options for the current dropdown
                                            placeholder="Select Scenario"
                                            name={`status-${index}`} // Unique name for each select
                                            className={`mt-0 ${receCss.scenarioSelect}`}
                                            classNamePrefix="select"
                                            styles={customStyles}
                                            isClearable={false}
                                            isSearchable={false}
                                            disabled={true}
                                        />
                                    </div>
                                ))}
                            </div>
                        // :
                        // subMappingActiveTab === 3 ? 
                        //     <div className={receCss.selectContainerWrapper}>
                        //         {perProductClassfLables?.map((label, index) => (
                        //             <div className={receCss.selectContainerTab} key={index}>
                        //                 <div>{label}</div>
                        //                 <Select
                                                // components={{ IndicatorSeparator: () => null }}
                        //                     key={index}
                        //                     value={selectedSubMappingData.productClassificationStages[index]?.values?.[0] 
                        //                         ? { label: selectedSubMappingData.productClassificationStages[index].values[0], value: selectedSubMappingData.productClassificationStages[index].values[0] }
                        //                         : null
                        //                     }
                        //                     onChange={(selectedOption) => handleSetSelectChange(selectedOption, index, 'productClassification')}
                        //                     options={perProductClassfFields} // Provide the options for the current dropdown
                        //                     placeholder="Select Scenario"
                        //                     name={`status-${index}`} // Unique name for each select
                        //                     className={`mt-0 ${receCss.scenarioSelect}`}
                        //                     classNamePrefix="select"
                        //                     styles={customStyles}
                        //                     isClearable={false}
                        //                     isSearchable={false}
                        //                 />
                        //             </div>
                        //         ))}
                        //     </div>
                        : null
                    }
                </div>

                <div className={receCss.cutModelFooterContainer}>
                    <button
                        type="button"
                        onClick={() => {setsubReceivablesMapping(false)}}
                        className={receCss.custModelFooterBtnSecondary}
                    >
                        Cancel
                    </button>

                    <button
                        type="button"
                        onClick={() => {saveSubMapping()}}
                        className={receCss.custModelFooterBtnPrimary}
                    >
                        Continue
                    </button>
                </div>
            </div>
        </div>
  );
};



export const customStyles = {
  control: (provided, state) => ({
    ...provided,
    backgroundColor: '#f4faf5',
    borderColor: '#c2e6d1',
    color: '#b3c0bd',
    boxShadow: state.isFocused ? '0 0 0 1px #c2e6d1' : 'none',
    borderWidth: '1px',
    borderRadius: '10px',
    '&:hover': {
      borderColor: '#b3c0bd',
    },
    minHeight: '38px',
    height: '38px',
  }),
  valueContainer: (provided) => ({
    ...provided,
    padding: '2px 8px',
    paddingTop: '1px',
  }),
  input: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  placeholder: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    fontSize: '14px',
  }),
  singleValue: (provided) => ({
    ...provided,
    color: '#4d6d64',
    fontSize: '14px',
  }),
  multiValue: (provided) => ({
    ...provided,
    backgroundColor: '#e0f5e9',
    borderRadius: '0.25rem',
    border: '1px solid #c2e6d1',
    width: 'fit-content',
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: '#4d6d64',
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      backgroundColor: '#c2e6d1',
      color: '#4f665f',
    },
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    color: '#b3c0bd',
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: '#205a46', 
    ':hover': {
        color: '#205a46',
    },
    }),
  clearIndicator: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    ':hover': {
      color: '#4f665f',
    },
  }),
  menu: (provided) => ({
    ...provided,
    backgroundColor: '#ffffff',
    border: '1px solid #c2e6d1',
    borderRadius: '10px',
    boxShadow: '0 0 0 1px #c2e6d1',
    marginTop: '6px',
    zIndex: 10,
  }),
  menuList: (provided) => ({
    ...provided,
    padding: '4px',
    borderRadius: '10px',
  }),
//   option: (provided, state) => ({
//     ...provided,
//     backgroundColor: state.isSelected
//       ? '#c2e6d1'
//       : state.isFocused
//       ? '#f4faf5'
//       : 'transparent',
//     color: '#4f665f',
//     padding: '10px 12px',
//     cursor: 'pointer',
//     fontSize: '14px',
//     borderRadius: '8px',
//     // margin: '4px 6px',
//   }),
option: (provided, state) => ({
  ...provided,
  backgroundColor: state.isFocused
    ? '#f4faf5'
    : 'transparent', 
  color: '#4f665f',
  padding: '10px 12px',
  cursor: 'pointer',
  fontSize: '14px',
  borderRadius: '8px',
}),

  noOptionsMessage: (provided) => ({
    ...provided,
    color: '#b3c0bd',
    padding: '8px 12px',
  }),
};
